"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _get = _interopRequireDefault(require("lodash/get"));
(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();
var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};
var _default = function _default(config) {
  return {
    serviceName: 'retrieveNotificationThresholdState',
    authenticate: true,
    config: {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      url: (0, _get.default)(config, 'endpoints.prompt.notifications.thresholdState')
    }
  };
};
var _default2 = _default;
exports.default = _default2;
;
(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;
  if (!reactHotLoader) {
    return;
  }
  reactHotLoader.register(_default, "default", "/builds/audacious-inquiry/portfolio/prompt/prompt-application/clone/components/prompt-client/src/services/service-configs/notifications/retrieve-notification-threshold-state.js");
})();
;
(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJjb25maWciLCJzZXJ2aWNlTmFtZSIsImF1dGhlbnRpY2F0ZSIsIm1ldGhvZCIsImhlYWRlcnMiLCJBY2NlcHQiLCJ1cmwiLCJnZXQiXSwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvc2VydmljZXMvc2VydmljZS1jb25maWdzL25vdGlmaWNhdGlvbnMvcmV0cmlldmUtbm90aWZpY2F0aW9uLXRocmVzaG9sZC1zdGF0ZS5qcyJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgZ2V0IGZyb20gJ2xvZGFzaC9nZXQnO1xuXG5leHBvcnQgZGVmYXVsdCAoY29uZmlnKSA9PiAoe1xuXHRzZXJ2aWNlTmFtZTogJ3JldHJpZXZlTm90aWZpY2F0aW9uVGhyZXNob2xkU3RhdGUnLFxuXHRhdXRoZW50aWNhdGU6IHRydWUsXG5cdGNvbmZpZzoge1xuXHRcdG1ldGhvZDogJ1BPU1QnLFxuXHRcdGhlYWRlcnM6IHtcblx0XHRcdEFjY2VwdDogJ2FwcGxpY2F0aW9uL2pzb24nLFxuXHRcdFx0J0NvbnRlbnQtVHlwZSc6ICdhcHBsaWNhdGlvbi9qc29uJyxcblx0XHR9LFxuXHRcdHVybDogZ2V0KGNvbmZpZywgJ2VuZHBvaW50cy5wcm9tcHQubm90aWZpY2F0aW9ucy50aHJlc2hvbGRTdGF0ZScpLFxuXHR9LFxufSk7XG4iXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFBQTtBQUE2QjtFQUFBO0VBQUE7QUFBQTtBQUFBO0VBQUE7QUFBQTtBQUFBLGVBRWQsa0JBQUNBLE1BQU07RUFBQSxPQUFNO0lBQzNCQyxXQUFXLEVBQUUsb0NBQW9DO0lBQ2pEQyxZQUFZLEVBQUUsSUFBSTtJQUNsQkYsTUFBTSxFQUFFO01BQ1BHLE1BQU0sRUFBRSxNQUFNO01BQ2RDLE9BQU8sRUFBRTtRQUNSQyxNQUFNLEVBQUUsa0JBQWtCO1FBQzFCLGNBQWMsRUFBRTtNQUNqQixDQUFDO01BQ0RDLEdBQUcsRUFBRSxJQUFBQyxZQUFHLEVBQUNQLE1BQU0sRUFBRSwrQ0FBK0M7SUFDakU7RUFDRCxDQUFDO0FBQUEsQ0FBQztBQUFBO0FBQUE7QUFBQTtBQUFBO0VBQUE7RUFBQTtJQUFBO0VBQUE7RUFBQTtBQUFBO0FBQUE7QUFBQTtFQUFBO0VBQUE7QUFBQSJ9